/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { fromPromise } from 'rxjs/observable/fromPromise';
import { Toast } from 'cx-ui-components';
import { of } from 'rxjs/observable/of';
import { sdkPromise } from '../../../../utils/sdk';
import { startReportingSubscriptions, reportingSubscriptionStarted } from './index';
import { getCurrentEntity } from '../../entities/selectors';
import { handleSuccess } from '../../entities/handleResult';
import { getBulkSelected } from './selectors';

export const StartBatchRequest = (action$, store) =>
  action$.ofType('START_INTERACTION_MANAGEMENT_BATCH_REQUEST_$').switchMap((action) =>
    fromPromise(
      sdkPromise({
        module: 'reporting',
        command: `bulkAddStatSubscription`,
        data: {
          queries: [
            { statistic: 'interactions-in-conversation-list', statId: 'interactions-in-conversation-list' },
            { statistic: 'interactions-in-queue-list', statId: 'interactions-in-queue-list' },
            { statistic: 'interactions-in-routing-list', statId: 'interactions-in-routing-list' },
          ],
        },
        topic: `cxengage/reporting/stat-subscription-added`,
      })
    ).mapTo(startReportingSubscriptions())
  );

export const StartBatchSubscription = (action$, store) =>
  action$.ofType('START_INTERACTION_MANAGEMENT_REPORTING_SUBSCRIPTION_$').switchMap((action) =>
    fromPromise(
      sdkPromise({
        module: 'subscribe',
        command: 'cxengage/reporting/batch-response',
        topic: 'cxengage/reporting/batch-response',
      })
    ).mapTo(reportingSubscriptionStarted())
  );

export const deleteInteraction = (action$, store) =>
  action$
    .ofType('DELETE_INTERACTION_BY_ID')
    .filter(({ entityId }) => getCurrentEntity(store.getState()) === 'interactionManagement')
    .switchMap(({ entityId, ...a }) =>
      fromPromise(
        sdkPromise({
          crudAction: 'delete',
          path: ['interactions', a.interactionId],
          command: 'endInteraction',
          module: 'entities',
          topic: 'v1/tenants/{{tenant-id}}/interactions/{{interaction-id}}',
        })
      )
        .map((response) => {
          Toast.success(response && response.message ? response.message : 'Interaction ended successfully..!!');
          return {
            type: 'TOGGLE_BULK_INTERACTION_CHANGE',
            interactionId: a.interactionId,
            isChanged: false,
            afterDeletion: true,
          };
        })
        .catch((error) => {
          Toast.error("Couldn't end the interaction " + error && error.message ? error.message : ' please try again..');
          return of({
            type: 'TOGGLE_BULK_INTERACTION_CHANGE',
            interactionId: a.interactionId,
            isChanged: false,
            afterDeletion: true,
          });
        })
    );
